export default __webpack_public_path__ + "static/media/brush2.1b1c0c3c.png";